import { render, staticRenderFns } from "./Porcentajes.vue?vue&type=template&id=048953ea&scoped=true"
import script from "./Porcentajes.vue?vue&type=script&lang=js"
export * from "./Porcentajes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048953ea",
  null
  
)

export default component.exports